import { useCallback, useRef } from "react";

const useSegmentTabs = ({ onChangeTab, tabs }: any) => {
  const allTabs = useRef(tabs);

  const changeActiveTab = useCallback(
    (tab: any) => {
      onChangeTab && onChangeTab(tab);
    },
    [onChangeTab]
  );

  return { changeActiveTab, allTabs };
};

export default useSegmentTabs;
